<p class="section-description">
  The real Usage &amp; Billing dashboard rendered against a patched <code>loadDashboard</code>. Unlike the Recovery and
  Backup previews this one is interactive — the period presets, Daily/Monthly toggle, cloud filter, tab switch, search
  and row expansion all work, and most states are only reachable through them. Export is live and will hit the real API.
</p>

<label class="recovery-screen-picker">
  <span class="recovery-screen-picker-label">Scenario</span>
  <select class="arpio-select" (change)="setUsageBillingScenario($any($event.target).value)">
    <optgroup *ngFor="let group of usageBillingScenarioGroups" [label]="group.label">
      <option
        *ngFor="let scenario of group.scenarios"
        [value]="scenario.key"
        [selected]="scenario.key === usageBillingScenarioKey"
      >
        {{ scenario.label }}
      </option>
    </optgroup>
  </select>
</label>
<p class="recovery-screen-description">{{ usageBillingActiveScenario.description }}</p>

<!-- The page assumes it owns the viewport (sticky header, 100vh-based
     pane height), so the frame gives it a bounded height and its own
     scroll context. Sticky pinning therefore differs slightly from the
     real route — verify that on /account/usage itself. -->
<div class="usage-billing-frame">
  <app-usage-billing *ngIf="usageBillingMounted"></app-usage-billing>
</div>
